import listPrompt from 'emun.report/quick-report-prompt'
import $session from 'servicestack/session'
import resolve from 'ioc/resolve'
import QuickReportPromptController from 'emun.report/quick-report-prompt.controller'

const quickReportPrompt = {
  open(options) {
    return modals.open(angular.extend({
      templateUrl,
      resolve: {
        options: () => options
      },
      controller: QuickReportPromptController,
      controllerAs: '$ctrl'
    }, (options || {}).modal)).result;
  }
};

function QuickReportPromptDirective($window, $parse) {
    // Introduce custom elements for IE8
    $window.document.createElement('quick-report-prompt');
    return {
        scope: false,
        link: function (scope, element, attr) {
            let onNoteCreated = attr.onNoteCreated || attr.onNoteSaved;
          let $targets = (attr.quickReportPromptClickSelector ? element.find(attr.quickReportPromptClickSelector) : element);
            $targets.on('click', e => {
              var model = scope.$eval(attr.quickReportPrompt || attr.ngModel ||  attr.quickReport) || {
                quickReport: attr.quickReport,
                };
              quickReportPrompt.open({ title: attr.title, scope, attr, element, $targets, model }).then(
                    (saved) => {
                        if (attr.onQuickReportSaved) {
                            $parse(attr.onQuickReportSaved)(scope, { $saved: saved })
                        }
                    }, () => {
                        if (attr.onDismissed) {
                            $parse(attr.onDismissed)(scope, {})
                        }
                    });
            });
        }
    }
};

export default QuickReportPromptDirective;